import React, { useContext, useEffect, useState } from "react";

import { GlobalContext } from "../../../../app/providers/GlobalState";

import { useFiltros } from "../FiltrosContext";

import BotaoAdicionar from "./BotaoAdicionar";
import CaixaPesquisa from "./CaixaPesquisa";
import FiltroSelect from "./FiltroSelect";
import SwitchAtivo from "./SwitchAtivo";
import BotaoVoltar from "./BotaoVoltar";

const FiltrosDesktop = ({ edicoes, categorias }) => {
    const globalContext = useContext(GlobalContext);
    const acesso = globalContext.acessos?.find(x => x.func === 1);

    const { pesquisa, setPesquisa, edicao, setEdicao, categoria, setCategoria, ativo, setAtivo, setDrawerVisivel, setTurmaId } =
        useFiltros();

    return (
        <div className="filtros filtros-desktop" style={{ display: "block" }}>
            <div className="bloco-filtros-1" style={{ gap: 10 }}>
                {acesso?.create && (
                    <div>
                        <BotaoAdicionar
                            ativo={ativo}
                            onClick={() => {
                                setDrawerVisivel(true);
                                setTurmaId(null);
                            }}
                        />
                    </div>
                )}
                <div className="bloco-pesquisa bloco-filtros-2">
                    <CaixaPesquisa pesquisa={pesquisa} placeholder="Procura" tem_placeholder onChange={setPesquisa} />
                    <FiltroSelect value={edicao} options={edicoes} onChange={setEdicao} placeholder="Edição" />
                    <FiltroSelect value={categoria} options={categorias} onChange={setCategoria} placeholder="Nível" />
                </div>
                <div style={{ display: "flex", alignItems: "center" }}>
                    <SwitchAtivo checked={ativo} onChange={setAtivo} />
                    <BotaoVoltar to="/utilizador" />
                </div>
            </div>
        </div>
    );
};

export default FiltrosDesktop;
